import { observer } from "mobx-react-lite";
import React from "react";
import { FormButtons, SideOverlay } from "../../../components";
import { FormProvider } from "react-hook-form";
import { FTPInput } from "../../../components-new";
import useAddContacts from "../pw-hooks/useAddContacts";

export const AddKeyContacts = observer((props: any) => {
  const { add_key_contacts, close_modal, methods, onSubmit } = useAddContacts();
  return (
    <SideOverlay
      onClose={close_modal}
      show={add_key_contacts}
      title={"Add Key Contacts"}
    >
      <FormProvider {...methods}>
        <form
          onSubmit={methods.handleSubmit(onSubmit)}
          className="bg-white px-4 py-2 rounded-sm flex flex-col gap-y-4"
        >
          <FTPInput label={"Name"} name={"name"} />
          <FTPInput name={"phone"} label={"Phone Number"} />
          <FTPInput name={"alternate_phone"} label={"Alternate Phone Number"} />
          <FTPInput label={"Mail"} name={"email"} />
          <FTPInput
            label={"Address"}
            name={"address"}
            multiline
            rows={3}
            fullWidth
          />
          <FTPInput label={"Designation"} name={"designation"} />
          <FTPInput
            label={"Comments"}
            name={"comments"}
            multiline
            rows={3}
            fullWidth
          />
          <FormButtons onSave={() => {}} onCancel={close_modal} />
        </form>
      </FormProvider>
    </SideOverlay>
  );
});
